export const state = {
  pagingLimit: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/employeeboard/state.js